var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.08183 7.64209L7.31152 7.64209L12.9213 7.64209C13.8812 7.64209 14.3612 6.48215 13.6812 5.80217L8.50147 0.622423C7.67151 -0.207537 6.32157 -0.207537 5.49161 0.622422L3.52171 2.59233L0.311865 5.80217C-0.358103 6.48215 0.121875 7.64209 1.08183 7.64209Z",
    fill: "#1B224C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.a4920d6611c1d9abf4813bc11ff94516.svg";
export { ForwardRef as ReactComponent };